import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { CREATE, UPDATE } from '../shared/constant';
import { BehaviorSubject, Observable, Subject, } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class SharedApiService {
  private customerDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public data$: Observable<any> = this.customerDetails.asObservable();
  private _selectedRoom: Subject<any> = new Subject<any>();
  public tenant: any = "";
  positions = NbGlobalPhysicalPosition;
  private paymentDataSubject = new BehaviorSubject<any>(null);
  paymentData$ = this.paymentDataSubject.asObservable();
  private paymentData: any = null;
  public hubConnection: signalR.HubConnection;
  public notifications: any[] = [];
  public unreadCount = 0;
  public unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  // Common APIs
   //baseUrl = environment.apiUrl;
  //baseUrl = "https://localhost:44342/";
  baseUrl = "https://api.lodge.hotelierpune.in/";
 
  constructor(private http: HttpClient, private toastrService: NbToastrService) {
    //this.baseUrl = "https://localhost:44342/";
  }
  
  public startSignalRConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(`${this.baseUrl}notificationhub`, {    
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets, 
        withCredentials: true
      })
      .build();
  
    this.hubConnection
      .start()
      .catch(err => console.error('SignalR error:', err));
  
    this.hubConnection.on('ReceiveNotification', (data) => {
      this.notifications.unshift({ ...data, isNew: true });
      this.unreadCount++;
      this.unreadCountSubject.next(this.unreadCount);
    });
}

  getUnreadNotifications(): Observable<any> {
    this.setTenant();
    let headers = new HttpHeaders({
      'tenant': this.tenant,
      'Content-Type': 'application/json',
    });
    let options = { headers: headers };
    let url = `${this.baseUrl}api/lodge/OnlineOrder/GetUnread`;

    return this.http.get<any>(url, options);
  }
  
  getAllNotifications(): Observable<any> {
    this.setTenant();
    let headers = new HttpHeaders({
      'tenant': this.tenant,
      'Content-Type': 'application/json',
    });
    let options = { headers: headers };
    let url = `${this.baseUrl}api/lodge/OnlineOrder/GetAll`;

    return this.http.get<any>(url, options);
  }
  
 
  markAsRead(id: number): Observable<any> {
    this.setTenant();
    let headers = new HttpHeaders({
      'tenant': this.tenant,
      'Content-Type': 'application/json',
    });
    let options = { headers: headers };
    let url = `${this.baseUrl}api/lodge/OnlineOrder/MarkAsRead/${id}`;

    return this.http.put<any>(url, {}, options);
  }
 
  markAllAsRead(): Observable<any> {
    this.setTenant();
    let headers = new HttpHeaders({
      'tenant': this.tenant,
      'Content-Type': 'application/json',
    });
    let options = { headers: headers };
    let url = `${this.baseUrl}api/lodge/OnlineOrder/MarkAllAsRead`;

    return this.http.put<any>(url, {}, options);
  }
  
   mapReservationManually(bookingId: string, hotelCode: string): Observable<any> {
    this.setTenant();

    const headers = new HttpHeaders({
      'tenant': this.tenant,
      'Content-Type': 'application/json',
    });

    const body = {
      bookingId: bookingId,
      hotelCode: hotelCode
    };

    const url = `${this.baseUrl}lodge/OnlineOrderReceive/MapReservationManually`;

    return this.http.post<any>(url, body, { headers: headers });
  }
  
  resetUnread() {
    this.unreadCount = 0;
    this.unreadCountSubject.next(this.unreadCount); 
    this.notifications.forEach(n => n.isNew = false);
  }
  
  // Method to update payment data
  setPaymentData(data: any) {
    this.paymentDataSubject.next(data);
  }
  getPaymentData() {
    return this.paymentData;
  }
  public saveData(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
    this.tenant = value.tenantName
  }

  public getData(key: string) {
    var data: any = sessionStorage.getItem(key);
    if (data) {
      this.tenant = data.tenantName
      return JSON.parse(data);
    }
    else
      return null;
  }

  public removeData(key: string) {
    sessionStorage.removeItem(key);
  }

  public clearData() {
    sessionStorage.clear();
  }

 setSelectedRoomData(data: any): void {
    this._selectedRoom = data;
  }

  getSeletedRoomData() {
    return this._selectedRoom;
  }

  showToastMessage(status, message) {
    let position = this.positions.TOP_RIGHT;
    let duration = 5000;
    this.toastrService.show(message, status, { position, status, duration });
  }

  setTenant() {
    let data: any = sessionStorage.getItem('userDetail');
    if (data) {
      data = JSON.parse(data);
      this.tenant = data.tenantName;
    }
  }

  //LoadCustomerDetail Api
  public LoadCustomerDetail(custId: number): Observable<any> {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/CustomerDetail/GetById?id=" + custId;

    return this.http.get(url, httpOptions);
  }

  //Api delete customer Detail
  public onDelete(custId: number): Observable<any> {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/CustomerDetail/DeleteById?id=" + custId;

    return this.http.delete(url, httpOptions);
  }

  public getCityName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Master/GetCityName";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public searchCityName(name: any) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/Master/SearchCityName?name=" + name;
    return this.http.get(url, httpOptions);
  }

  public getCustomerTypeName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Master/GetCustomerType";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public getGenderName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Lodge/Master/GetAllGenders";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public getIdentityCardTypeName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Master/GetIdentityCardType";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  // public createUpdateCustomerDetail(action, customerDetailRequest: any) {
  //   this.setTenant();
  //   let headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'tenant': this.tenant
  //   });
  //   let options = { headers: headers };
  //   let url = "";

  //   if (action == CREATE)
  //     url = this.baseUrl + "api/CustomerDetail/Create";
  //   else
  //     url = this.baseUrl + "api/CustomerDetail/Update";

  //   return this.http.post<any>(url, customerDetailRequest, options);
  // }
  createUpdateCustomerDetail(action, customerDetailRequest: FormData) {
    this.setTenant();
    let headers = new HttpHeaders({
      
      'tenant': this.tenant
    });
    let options = { headers: headers };
    let url = "";

    if (action == CREATE)
      url = this.baseUrl + "api/CustomerDetail/Create";
    else
      url = this.baseUrl + "api/CustomerDetail/Update";

    return this.http.post<any>(url, customerDetailRequest, options);
  }

  
  
  
  public checkMobileNoExists(mobileNo: string, customerId?: number): Observable<any> {
    this.setTenant();
  
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
  
    let url = `${this.baseUrl}api/CustomerDetail/CheckMobileNoExists?mobileNo=${mobileNo}`;
    
    if (customerId) {
      url += `&customerId=${customerId}`;
    }
  
    return this.http.get(url, httpOptions);
  }
  
  checkGstNoExists(gstNo: string): Observable<any> {
  this.setTenant(); 
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Tenant': this.tenant
    })
  };

  const url = `${this.baseUrl}api/CustomerDetail/CheckGstNoExists?gstNo=${gstNo}`;
  return this.http.get(url, httpOptions);
}



  
  //Employee Detail API
  /*public createUpdateEmployeeDetail(action, employeeDetailRequest: any) {
    this.setTenant();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'tenant': this.tenant
    });
    let options = { headers: headers };
    let url = "";

    if (action == CREATE)
      url = this.baseUrl + "api/Employee/Create";
    else
      url = this.baseUrl + "api/Employee/Update";

    return this.http.post<any>(url, employeeDetailRequest, options);
  }

  public getAllEmployee() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + 'api/Employee/GetAll';
    return this.http.get(url, httpOptions);
  }

 public getEmployeeDetailById(id: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/Employee/GetById?Id=" + id;
    return this.http.get(url, httpOptions);
  }

  public deleteEmployee(id: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + 'api/Employee/DeleteById?id=' + id;
    return this.http.delete(url, httpOptions);
  }*/
    public createUpdateEmployeeDetail(action, employeeDetailRequest: any) {
      this.setTenant();
      let httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Tenant': this.tenant
          })
      };
  
      // If updating, ensure the request contains an ID
      let url = action === CREATE 
          ? `${this.baseUrl}api/Employee/Create` 
          : `${this.baseUrl}api/Employee/Update?id=${employeeDetailRequest.id}`; // Append ID if required
  
      return this.http.post<any>(url, employeeDetailRequest, httpOptions);
  }
  
    
    public getAllEmployee() {
      this.setTenant();
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Tenant': this.tenant
        }),
      };
      let url = `${this.baseUrl}api/Employee/GetAll`;
      return this.http.get(url, httpOptions);
    }

     public getEmployeeCode() {
      this.setTenant();
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Tenant': this.tenant
        }),
      };
      let url = `${this.baseUrl}api/Employee/GetNewEmployeeCode`;
      return this.http.get(url, httpOptions);
    }
    
    public editEmployee(id: number) {
      this.setTenant();
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Tenant': this.tenant
        }),
      };
      let url = this.baseUrl+'api/Employee/GetById?id=' +id;
      return this.http.get(url, httpOptions);
    }
    
    public deleteEmployee(id: number) {
      this.setTenant();
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Tenant': this.tenant
        }),
      };
      let url = this.baseUrl + 'api/Employee/DeleteById?id=' + id;
      return this.http.delete(url, httpOptions);
    }
    

  public getAllCustomerDetail() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/CustomerDetail/GetAll";
    return this.http.get(url, httpOptions);
  }

  public getCustomerDetailById(custId: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/CustomerDetail/GetById?Id=" + custId;
    return this.http.get(url, httpOptions);
  }

  public deleteCustomerDetail(custId) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/CustomerDetail/DeleteById?id=" + custId;
    return this.http.delete(url, httpOptions);
  }

  public getCustomerByNameMobile(searchBy, value) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/CustomerDetail/GetByNameMobile?searchBy=" + searchBy + "&value=" + value;
    return this.http.get(url, httpOptions);
  }
 private selectedCustomerSource = new BehaviorSubject<any>(null);
  selectedCustomer$ = this.selectedCustomerSource.asObservable();

  sendCustomer(data: any) {
    this.selectedCustomerSource.next(data);
  }
  public getDesignationName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Master/GetDesignation";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public getDepartmentName() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/Master/GetDepartment";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public getEmployeeDetailById(id: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };
    let url = this.baseUrl + "api/Employee/GetById?Id=" + id;
    return this.http.get(url, httpOptions);
  }

  public getCustomerByTypeValue(typeValue, value) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/CustomerDetail/GetByCustTypeValue?typeValue=" + typeValue + "&value=" + value;
    return this.http.get(url, httpOptions);
  }

  // Register User API
  registerUser(emailId: string): Observable<any> {
    const params = { emailId }; // API expects an emailId parameter
    return this.http.get<any>(this.baseUrl + "api/Auth/UserRegistrationOtp", { params });
  }

  //login API

  onlogin(username: string, password: string): Observable<any> {
    const url = `${this.baseUrl + "Auth/Login"}?userName=${username}&password=${password}`;
    return this.http.get(url);
  }
/////// code for file upload in shop detail file upload
  uploadShopFiles(shopLogo: File, shopPdf: File): Observable<any> {
    const formData = new FormData();
    formData.append('shopLogo', shopLogo); // Append logo file
    formData.append('shopPdf', shopPdf); // Append PDF file

    return this.http.post<any>(this.baseUrl, formData);
  }








  /////create api for UserRole

 /* public createUpdateUserRole(action: string, payload: any) {
    this.setTenant();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'tenant': this.tenant,
    });
    const options = { headers: headers };
    let url = '';

    if (action === CREATE)
      url = this.baseUrl + 'api/UserDetail/CreateUserRole';
    //else
      url = this.baseUrl + 'api/UserDetail/UpdateUserRole'; // change if you have one

    return this.http.post<any>(url, payload, options);
  }*/
    public createUpdateUserRole(action: string, payload: any) {
      this.setTenant();
    
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'tenant': this.tenant,
      });
      const options = { headers: headers };
      let url = '';
    
      if (action === CREATE) {
        url = this.baseUrl + 'api/UserRole/Create';
      } else if (action === UPDATE) {
        url = this.baseUrl + 'api/UserRole/Update';
      } else {
        throw new Error('Invalid action type.');
      }
    
      return this.http.post<any>(url, payload, options);
    }
    
    
    public getUserRoleById(id: any,tenantId: number) {
      this.setTenant();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      });
    
      const url = this.baseUrl + 'api/UserRole/GetById?Id=' + id + '&tenantId=' + tenantId;
      return this.http.get(url, { headers });
    }
    


  public getAllUserRole(tenantId: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

     let url = this.baseUrl + "api/UserRole/GetAll?tenantId=" + tenantId;

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public deleteUserRole(id:any) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/UserRole/DeleteById?id=" + id;
    return this.http.delete(url, httpOptions);
  }

   public CreateUpdateLodgeHotelForm(action: string, payload: any) {
      this.setTenant();
    
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'tenant': this.tenant,
      });
      const options = { headers: headers };
      let url = '';
    
      if (action === CREATE) {
        url = this.baseUrl + 'api/UserRole/CreateLodgeHotelForm';
      } else if (action === UPDATE) {
        url = this.baseUrl + 'api/UserRole/UpdateLodgeHotelForm';
      }
      else {
        throw new Error('Invalid action type.');
      }
    
      return this.http.post<any>(url, payload, options);
    }

    public GetAllLodgeHotelForm() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/UserRole/GetAllLodgeHotelForm";

    var data = this.http.get(url, httpOptions);

    return data;
  }

   public GetLodgeHotelForm(id: any) {
      this.setTenant();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      });
    
      const url = this.baseUrl + 'api/UserRole/GetByIdLodgeHotelForm?Id=' + id;
      return this.http.get(url, { headers });
    }

    public DeleteLodgeHotelForm(id:any) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/UserRole/DeleteByIdLodgeHotelForm?id=" + id;
    return this.http.delete(url, httpOptions);
  }

   public createRolePermission(payload: any) {

  this.setTenant();

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Tenant': this.tenant,
  });

  const url = this.baseUrl + 'api/UserRole/CreateRolePermission';

  return this.http.post<any>(url, payload, { headers });
}


  public updateRolePermissionByRole(payload: any) {

  this.setTenant();

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Tenant': this.tenant
    })
  };

  const url = this.baseUrl + 'api/UserRole/UpdateRolePermissionByRole';

  return this.http.post<any>(url, payload, httpOptions);
}

     public getAllRolePermission(tenantId: number) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl +  "api/UserRole/GetAllRolePermission?tenantId=" + tenantId;
    var data = this.http.get(url, httpOptions);

    return data;
  }


  public getRolePermissionByRoleId(userRoleId: any,tenantId: number) {
      this.setTenant();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      });
    
      const url = this.baseUrl +   'api/UserRole/GetRolePermissionByRoleId?userRoleId=' +
    userRoleId + '&tenantId=' + tenantId;
      return this.http.get(url, { headers });
    }

    public deleteRolePermission(id:any) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/UserRole/DeleteByIdRolePermission?id=" + id;
    return this.http.delete(url, httpOptions);
  }

  
 
  public bellClickedSource = new Subject<void>();

 
  public bellClicked$ = this.bellClickedSource.asObservable();

 
  notifyBellClicked() {
    this.bellClickedSource.next();
  }

  public GetAllDepartment() {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/hotel/PurchaseDepartment/GetAllDepartment";

    var data = this.http.get(url, httpOptions);

    return data;
  }

  public createUpdatedepartmet(action: string, payload: any) {
    this.setTenant();
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'tenant': this.tenant,
    });
    const options = { headers: headers };
    let url = '';
  
    if (action === CREATE) {
      url = this.baseUrl + 'api/hotel/PurchaseDepartment/CreateDepartment';
    } else if (action === UPDATE) {
      url = this.baseUrl + 'api/hotel/PurchaseDepartment/UpdateDepartment';
    } else {
      throw new Error('Invalid action type.');
    }
  
    return this.http.post<any>(url, payload, options);
  }
  
  public deletedepartment(id:any) {
    this.setTenant();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Tenant': this.tenant
      }),
    };

    let url = this.baseUrl + "api/hotel/PurchaseDepartment/DeleteByIdDepartment?id=" + id;
    return this.http.delete(url, httpOptions);
  }

  public getRolePermissions(tenantId: number, roleId: number) {
    const url = `${this.baseUrl}Auth/GetRolePermissions?tenantId=${tenantId}&roleId=${roleId}`;
    return this.http.get<any>(url);
  }

}